export default __webpack_public_path__ + "d12d98db9138a36a781bec584cdf0c7e.png";